import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from "../../environments/environment";
@Injectable({ providedIn: 'root' })
export class SellerDisconnectService {
    
    private currentUserSubject: BehaviorSubject<any>;

    backendUrl: string = environment.apiUrl;
    
    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
    }

    disconnectElenas(){
       const urlFinal = this.backendUrl + "/sellers/disconnect_elenas";

        const currentUser = this.currentUserSubject.value;

        return new Promise((resolve, reject) => {
            this.http.post<any>(urlFinal, {  
                seller_id: currentUser.seller_id
            }).subscribe( 
                (response) => resolve(true),
                (error) => reject(error)
            )
        });
    }


    disconnectLiverpool(){
        const urlFinal = this.backendUrl + "/sellers/disconnect_liverpool";
 
         const currentUser = this.currentUserSubject.value;
 
         return new Promise((resolve, reject) => {
             this.http.post<any>(urlFinal, {  
                 seller_id: currentUser.seller_id
             }).subscribe( 
                 (response) => resolve(true),
                 (error) => reject(error)
             )
         });
     }

     sincronizaInventario(seller_id,platform){
        const urlFinal = this.backendUrl + "/sellers/sincronizar_inventario"; 
         return new Promise((resolve, reject) => {
             this.http.post<any>(urlFinal, {  
                 seller_id: seller_id,platform:platform
             }).subscribe( 
                 (response) => resolve(true),
                 (error) => reject(error)
             )
         });
     }

     sincronizaOrdenes(seller_id,platform){
        const urlFinal = this.backendUrl + "/sellers/sincronizar_ordenes";
 
         const currentUser = this.currentUserSubject.value;
 
         return new Promise((resolve, reject) => {
             this.http.post<any>(urlFinal, {  
                seller_id: seller_id,platform:platform
             }).subscribe( 
                 (response) => resolve(true),
                 (error) => reject(error)
             )
         });
     }
}